import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Label } from 'semantic-ui-react';

const getCampaignLabelColor = type => {
  switch (type) {
  case 'ACR':
    return 'orange';
  case 'AUTOMATED_CAMPAIGN':
    return 'pink';
  default:
    return 'green';
  }
};

export default function CampaignTypeLabel({
  campaignType,
}) {
  const color = getCampaignLabelColor(campaignType);
  return (
    <Label size="mini" basic color={color}>{ _.upperCase(campaignType) }</Label>
  );
}


CampaignTypeLabel.propTypes = {
  campaignType: PropTypes.string.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/components/campaign-type-label/index.js
 **/